import type { ConversationNodeFilter } from 'lib-shared-types-api';
import type { ReactNode } from 'react';

import { operatorItems } from 'components/powerFlowShared/components/modals/filters/util/helper';

import { getVariableName } from './utils/variable/getVariableName';

type Props = {
  node: ConversationNodeFilter;
};

function getMatchText(node: ConversationNodeFilter): ReactNode {
  if (node.isMatching === false) {
    return 'No match';
  }

  const operator = Object.values(operatorItems).find(
    ({ id }) => id.toUpperCase() === node.matching_rule.toUpperCase(),
  );

  return (
    <>
      {getVariableName(node.variable_id)} {operator?.name}{' '}
      <strong>{node.value}</strong>
    </>
  );
}

export function RoutedThroughFilter({ node }: Props): JSX.Element {
  return (
    <>
      Filter <strong>{node.description}</strong> · {getMatchText(node)}
    </>
  );
}
